export default __webpack_public_path__ + "static/media/featured2-1.de2ba628.jpg";